import { useApolloClient } from '@apollo/react-hooks';

import {
  formatAttemptDateTime,
  formatQuizFeedAccuracy,
  formatQuizFeedScore,
  getStudentDisplayName,
  toQuizFeedReportVariables,
} from 'Domains/adaptiveQuiz';

import { getQuizFeedAttemptReport } from '../../GraphQL/queries/report.query';
import { writeGroupedHeaderWorkbook } from '../ExportAdaptiveQuizReportData/groupedHeaderWorksheet';
import { formatSchoolTerm } from '../utils';

export const ADAPTIVE_QUIZ_ATTEMPT_REPORT_COLUMNS = [
  { header: 'รอบที่', width: 8 },
  { header: 'หน่วย', width: 30 },
  { header: 'บท', width: 30 },
  { header: 'รหัสนักเรียน', width: 15 },
  { header: 'ชื่อ-นามสกุล', width: 25 },
  { header: 'วันเวลา', width: 25 },
  {
    group: 'จำนวนข้อสอบที่ทำ (ข้อ)',
    columns: [
      { header: 'Adaptive Quiz (ถูก/ทั้งหมด)', width: 22 },
      { header: '%Accuracy', width: 12 },
    ],
  },
];

export const convertAdaptiveQuizAttemptReportToAOA = quizFeedAttemptReport => {
  const { classroomUsername, attempts } = quizFeedAttemptReport;
  const displayName = getStudentDisplayName(quizFeedAttemptReport);

  return attempts.map(
    ({ attemptNo, courseCode, courseName, lessonName, startedAt, endedAt, adaptiveQuiz }) => [
      attemptNo,
      `${courseName} (${courseCode})`,
      lessonName,
      classroomUsername,
      displayName,
      formatAttemptDateTime(startedAt, endedAt),
      formatQuizFeedScore(adaptiveQuiz),
      formatQuizFeedAccuracy(adaptiveQuiz),
    ]
  );
};

const ExportAdaptiveQuizAttemptReportData = ({ filterValue, schoolCode, username, children }) => {
  const client = useApolloClient();

  const fetchAdaptiveQuizAttemptReportData = async () => {
    try {
      const { data } = await client.query({
        query: getQuizFeedAttemptReport,
        variables: {
          ...toQuizFeedReportVariables(filterValue),
          classroomUsername: username,
          schoolCode,
        },
      });
      return { data };
    } catch (error) {
      return { error };
    }
  };

  const exportAdaptiveQuizAttemptReport = ({ report: quizFeedAttemptReport }) => {
    const {
      schoolTerm: { name: schoolTermName, shortName: schoolTerm } = {},
      subject: { name: subject } = {},
      courseName,
    } = quizFeedAttemptReport;
    const displayName = getStudentDisplayName(quizFeedAttemptReport) || username;

    writeGroupedHeaderWorkbook({
      title: `ผลลัพธ์ Adaptive Quiz ${displayName} ${schoolTermName} วิชา${subject}`,
      columns: ADAPTIVE_QUIZ_ATTEMPT_REPORT_COLUMNS,
      rows: convertAdaptiveQuizAttemptReportToAOA(quizFeedAttemptReport),
      sheetName: 'Adaptive Quiz รายรอบ',
      fileName: `ผลลัพธ์AdaptiveQuiz_${username}_${formatSchoolTerm(
        schoolTerm
      )}_${subject}_${courseName}.xlsx`,
    });
  };

  return children({ fetchAdaptiveQuizAttemptReportData, exportAdaptiveQuizAttemptReport });
};

export default ExportAdaptiveQuizAttemptReportData;
